<template>
  <el-form label-position="top" :model="ruleForm">
    <el-form-item label="Level">
      <el-select
        v-model="ruleForm.level"
        multiple
        placeholder="Level"
        clearable
        style="width:100%"
      >
        <el-option label="LOW" value="0"></el-option>
        <el-option label="MEDIUM" value="1"></el-option>
        <el-option label="HIGH" value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Devices">
      <el-transfer
        v-model="ruleForm.deviceKey"
        :data="deviceOptions"
        :props="{ key: 'key', label: 'label', disabled: 'disabled' }"
        :titles="['Available Devices', 'Selected Devices']"
        :filterable="true"
        :filter-method="filterDevice"
        filter-placeholder="Search by device name or key"
        class="device-transfer"
        style="width: 100%"
      />
    </el-form-item>
  </el-form>
</template>
<script>
import { getAllAssetVo } from "@/api";

export default {
  name: "DeviceAlertParams",
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ruleForm: this.value
        ? { ...this.value }
        : {
            deviceKey: [],
            level: [],
          },
      deviceList: [],
    };
  },
  computed: {
    deviceOptions() {
      return (this.deviceList || []).map((item) => {
        const deviceKey = String(item.deviceKey || "");
        const name = item.name || deviceKey;

        return {
          key: deviceKey,
          label: name,
          disabled: !deviceKey,
          searchText: `${name} ${deviceKey}`.toLowerCase(),
        };
      });
    },
  },
  created() {
    this.normalizeRuleForm();
    this.loadDevices();
  },
  watch: {
    value: {
      handler(v) {
        if (v) {
          this.ruleForm = v;
          this.normalizeRuleForm();
        }
      },
      deep: true,
    },
    ruleForm: {
      handler(v) {
        this.normalizeRuleForm();
        this.$emit("input", v);
      },
      deep: true,
    },
  },
  methods: {
    async loadDevices() {
      try {
        const list = await getAllAssetVo();
        this.deviceList = Array.isArray(list) ? list : [];
      } catch (error) {
        this.deviceList = [];
      }
    },
    normalizeRuleForm() {
      if (!this.ruleForm || typeof this.ruleForm !== "object") return;

      if (!Array.isArray(this.ruleForm.level)) {
        this.$set(
          this.ruleForm,
          "level",
          this.ruleForm.level ? [this.ruleForm.level] : []
        );
      }

      const nextDeviceKeys = Array.isArray(this.ruleForm.deviceKey)
        ? this.ruleForm.deviceKey
        : this.ruleForm.deviceKey
          ? [this.ruleForm.deviceKey]
          : [];

      const normalized = nextDeviceKeys
        .map((item) => String(item))
        .filter(Boolean);

      if (!this.isSameArray(this.ruleForm.deviceKey, normalized)) {
        this.$set(this.ruleForm, "deviceKey", normalized);
      }
    },
    isSameArray(left, right) {
      if (!Array.isArray(left) || !Array.isArray(right)) return false;
      if (left.length !== right.length) return false;
      return left.every((item, index) => item === right[index]);
    },
    filterDevice(query, item) {
      const keyword = String(query || "").trim().toLowerCase();
      if (!keyword) return true;
      return item.searchText.includes(keyword);
    },
  },
};
</script>

<style scoped>
::v-deep .device-transfer {
  display: flex;
  align-items: center;
  gap: 12px;
}

::v-deep .device-transfer .el-transfer-panel {
  width: calc(50% - 34px);
  min-width: 260px;
  background: #1a2535;
  border: 1px solid #333b47;
  border-radius: 8px;
}

::v-deep .device-transfer .el-transfer-panel__header,
::v-deep .device-transfer .el-transfer-panel__body,
::v-deep .device-transfer .el-transfer-panel__list {
  background: #1a2535;
}

::v-deep .device-transfer .el-transfer-panel__header {
  border-bottom: 1px solid #333b47;
}

::v-deep .device-transfer .el-transfer-panel__header .el-checkbox__label,
::v-deep .device-transfer .el-transfer-panel__item .el-checkbox__label,
::v-deep .device-transfer .el-transfer-panel__empty {
  color: #e5e7eb;
}

::v-deep .device-transfer .el-transfer-panel__filter {
  padding: 12px;
}

::v-deep .device-transfer .el-transfer-panel__filter .el-input__inner {
  background: #182130;
  border-color: #333b47;
  color: #fff;
}

::v-deep .device-transfer .el-transfer-panel__filter .el-input__inner::placeholder,
::v-deep .device-transfer .el-transfer-panel__filter .el-input__icon {
  color: #8a9ab0;
}

::v-deep .device-transfer .el-transfer-panel__item.el-checkbox {
  color: #fff;
  margin-right: 0;
}

::v-deep .device-transfer .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .device-transfer .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fcb900;
  border-color: #fcb900;
}

::v-deep .device-transfer .el-checkbox__inner {
  background: #182130;
  border-color: #555;
}

::v-deep .device-transfer .el-transfer__buttons {
  padding: 0;
}

::v-deep .device-transfer .el-transfer__buttons .el-button {
  display: block;
  margin: 0 0 8px;
  background: #2c3850;
  border: 1px solid #3d4f68;
  color: #fff;
}

::v-deep .device-transfer .el-transfer__buttons .el-button:last-child {
  margin-bottom: 0;
}

::v-deep .device-transfer .el-transfer__buttons .el-button:hover:not(.is-disabled) {
  background: #fcb900;
  border-color: #fcb900;
  color: #111827;
}

::v-deep .device-transfer .el-transfer__buttons .el-button.is-disabled {
  opacity: 0.4;
}

::v-deep .device-transfer .el-transfer-panel__list::-webkit-scrollbar {
  width: 6px;
}

::v-deep .device-transfer .el-transfer-panel__list::-webkit-scrollbar-thumb {
  background-color: #4b5563;
  border-radius: 999px;
}

@media (max-width: 900px) {
  ::v-deep .device-transfer {
    flex-direction: column;
    align-items: stretch;
  }

  ::v-deep .device-transfer .el-transfer-panel {
    width: 100%;
    min-width: 0;
  }

  ::v-deep .device-transfer .el-transfer__buttons {
    display: flex;
    justify-content: center;
    gap: 8px;
  }

  ::v-deep .device-transfer .el-transfer__buttons .el-button {
    margin: 0;
  }
}
</style>
